import React, {useState} from 'react';
import {Translation, withTranslation, WithTranslation} from 'react-i18next';
import {useLoaderData} from "react-router-dom";
import {getApi} from "./api/Api";
import {Page as Model} from "./model/Page";
import 'draft-js/dist/Draft.css';
import {convertFromRaw, convertToRaw, Editor, EditorState} from 'draft-js';
import * as savedPage from './saved-page.json'
import {htmlText} from './saved-page-html'

export async function loader(obj: any) {
    const api = getApi()
    const page = await api.getPage(obj.params.pageId);
    return page
}

const Page = (props: PageProps) => {
    const page = useLoaderData() as Model

    const [editorState, setEditorState] = useState(EditorState.createWithContent(convertFromRaw(savedPage)))


    const onChange = (editorState: EditorState) => {
        setEditorState(editorState)
    }

    return !page ? (<div>Not found</div>) : (
        <Translation>
            {t =>
                <div>
                    <h2>{page.title}</h2>
                    <p>{page.text}</p>
                    <div className="container d-flex">
                        <span className="me-auto">{new Date(page.publishTimeMillisUtc).toLocaleString()}</span>
                    </div>
                    <div>
                        <Editor editorState={editorState} onChange={onChange} spellCheck={true}
                                stripPastedStyles={true}


                        />
                        <input multiple={true} value={JSON.stringify(convertToRaw(editorState.getCurrentContent()))}/>
                    </div>
                    <div dangerouslySetInnerHTML={{__html: htmlText}}/>
                </div>
            }
        </Translation>
    )
}

interface PageProps extends WithTranslation {
    // id: string;
}

export default withTranslation()(Page)

